import { DiContainer } from '@/modules/di/di-container';
import { createEffect, createEvent, createStore, sample } from 'effector';
import { LogisticsDataService } from '../services/logistics.service';
import { IRootTradeLogisticsData } from '../types';

const logisticsDataService = DiContainer.get(LogisticsDataService);

export const $specificRouteDataLoadingStatus = createStore<{ loading: boolean; error: boolean | Error }>({
  loading: false,
  error: false,
});
const setSpecificRouteDataLoadingStatus = createEvent<{
  loading: boolean;
  error: boolean | Error;
}>();
$specificRouteDataLoadingStatus.on(
  setSpecificRouteDataLoadingStatus,
  (_s, p) => p,
);

export const $specificRouteData = createStore<IRootTradeLogisticsData | null>(null);
export const setSpecificRouteData = createEvent<IRootTradeLogisticsData | null>();

$specificRouteData.on(setSpecificRouteData, (_s, p) => p);

export const fetchSpecificRouteDataFx = createEffect(
  async ({
    warehouse_id,
    trade_id,
    destination_id,
  }: {
    warehouse_id: number;
    trade_id: number;
    destination_id: number;
  }) => {
    try {
      setSpecificRouteDataLoadingStatus({ loading: true, error: false });
      const res = logisticsDataService.getBusinessOfferLogsticsData({
        warehouse_id,
        trade_id,
        destination_id,
      });
      setSpecificRouteDataLoadingStatus({ loading: false, error: false });
      return res;
    } catch (err) {
      setSpecificRouteDataLoadingStatus({ error: err as Error, loading: false });
    }
  },
);

sample({
  target: setSpecificRouteDataLoadingStatus as any,
  clock: fetchSpecificRouteDataFx.failData,
  fn: () => ({ error: true, loading: false })
})

sample({
    target: setSpecificRouteData as any,
    clock: fetchSpecificRouteDataFx.doneData,
})
